import { createAction } from 'redux-actions'

let datasets_data_request     = createAction('DATASETS_DATA_REQUEST')
let datasets_data_ready       = createAction('DATASETS_DATA_READY')
let datasets_data_failure     = createAction('DATASETS_DATA_FAILURE')

let get_dataset = public_guid => async dispatch => {
  dispatch(datasets_data_request({public_guid}))

  try 
  {
    // todo sanitize public_guid
    let response = await fetch(`http://warm-citadel-87065.herokuapp.com/v1/shared/${public_guid}`)
    if (!response.ok)
    {
      throw(new Error(response.status))
    }
    let dataset = await response.json()
    dispatch(datasets_data_ready({public_guid, dataset}))    
  }
  catch (error)
  {
    console.log(error)
    dispatch(datasets_data_failure({public_guid, error}))
  }
}

export let priv = {
  datasets_data_request,
  datasets_data_ready,
  datasets_data_failure
}

export default {
  get_dataset
}



// WEBPACK FOOTER //
// ./src/actions/shared-dataset.js